import { render, staticRenderFns } from "./Compras.vue?vue&type=template&id=e7899514&scoped=true"
import script from "./Compras.vue?vue&type=script&lang=js"
export * from "./Compras.vue?vue&type=script&lang=js"
import style0 from "./Compras.vue?vue&type=style&index=0&id=e7899514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7899514",
  null
  
)

export default component.exports